import { memorize } from "./utils";

export const setUrlParam = memorize((uri: string, key: string, value: string): string => {
  const sampleDomain = "http://sample.com";
  const url = new URL(sampleDomain + uri.replace(new RegExp("/$"), ""));

  if (value.length > 0) {
    url.searchParams.set(key, value);
  } else {
    url.searchParams.delete(key);
  }
  return url.href.replace(sampleDomain, "");
});

export const getUrlParam = memorize((search: string, key: string): string | null => {
  return new URLSearchParams(search).get(key);
});
